function cookieValueContainsMarketingTrue(value) {
    if (!value) return false;

    let decoded = value;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        decoded = value;
    }

    const normalized = decoded.toLowerCase();
    return /marketing\s*[:"]\s*true/.test(normalized) || normalized.indexOf('marketing:true') !== -1;
}

function getCookieValueByName(name) {
    const cookieString = document.cookie || '';
    if (!cookieString) return '';

    const encodedName = `${encodeURIComponent(name)}=`;
    const parts = cookieString.split(';');

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part.indexOf(encodedName) === 0) return part.substring(encodedName.length);
        if (part.indexOf(`${name}=`) === 0) return part.substring(name.length + 1);
    }

    return '';
}

function isMarketingAccepted() {
    // Prefer Cookiebot runtime state when available (updates immediately after renew/accept).
    if (window.Cookiebot && window.Cookiebot.consent) {
        return !!window.Cookiebot.consent.marketing;
    }

    const cookieConsentValue = getCookieValueByName('CookieConsent');
    return cookieValueContainsMarketingTrue(cookieConsentValue);
}

function addAutoplayParam(url) {
    if (url.indexOf('?') === -1) return `${url}?autoplay=1`;
    return `${url}&autoplay=1`;
}

function loadIframe(iframe, autoplay) {
    if (!iframe || iframe.getAttribute('src')) return;

    let src = iframe.getAttribute('data-src');
    if (!src) return;

    if (autoplay) src = addAutoplayParam(src);

    iframe.setAttribute('src', src);
    iframe.setAttribute('aria-hidden', 'false');
}

function refreshVideoBlock(wrapper) {
    const iframe = wrapper.querySelector('.video-embed');
    const consentNotice = wrapper.querySelector('.video-consent-notice');

    if (isMarketingAccepted()) {
        loadIframe(iframe, false);
        if (consentNotice) consentNotice.style.display = 'none';
    }
}

function initVideoBlock(wrapper) {
    const iframe = wrapper.querySelector('.video-embed');
    const playButton = wrapper.querySelector('[data-play-toggle]');
    const consentNotice = wrapper.querySelector('.video-consent-notice');

    refreshVideoBlock(wrapper);

    if (!playButton || playButton.dataset.videoConsentBound === 'true') return;
    playButton.dataset.videoConsentBound = 'true';

    playButton.addEventListener('click', (event) => {
        event.preventDefault();

        if (isMarketingAccepted()) {
            loadIframe(iframe, true);
            if (consentNotice) consentNotice.style.display = 'none';
        } else if (consentNotice) {
            consentNotice.style.display = '';
        }
    });
}

function initializeVideoConsent() {
    document.querySelectorAll('.video-component .video').forEach((wrapper) => {
        try {
            initVideoBlock(wrapper);
        } catch (error) {
            console.error('Video block init error', error);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVideoConsent);
} else {
    initializeVideoConsent();
}

// Re-check when Cookiebot consent changes at runtime.
window.addEventListener('CookiebotOnConsentReady', initializeVideoConsent);
window.addEventListener('CookiebotOnAccept', initializeVideoConsent);
window.addEventListener('CookiebotOnDecline', initializeVideoConsent);
